/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { GridItemProps } from "./GridItemProps";

/**
 * Renders the GridItem component.
 * @param props The properties.
 * @returns The GridItem component.
 */
export const GridItem: React.FC<GridItemProps> = props => {
    const { className, children } = props;

    return <div className={className}>{children}</div>;
};
